import type { ReactElement } from 'react';
import { SKELETON_CYCLE, skeletonLine } from '@/components/ui/skeleton';

/** Skeleton contextual del Editor y flujo (UX-LOAD-01): imita la forma real (panel de
 *  documento a la izquierda, stepper y acciones a la derecha), con fade-in. */
export function EditorSkeleton(): ReactElement {
  return (
    <div className="g-84 rise" aria-hidden="true">
      <div className="editorwrap">
        <div className="etb">
          <span className={skeletonLine({ width: 'md', height: 'sm' })} />
          <span className={skeletonLine({ width: 'sm', height: 'sm' }, 'fname')} />
        </div>
        <div className="noembed">
          <span className={skeletonLine({ width: 60, height: 'sm' })} />
        </div>
      </div>
      <div className="stack">
        <div className="card rise d1">
          <div className="cb" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {[0, 1, 2, 3].map((i) => (
              <span
                key={i}
                className={skeletonLine({
                  width: SKELETON_CYCLE[i % SKELETON_CYCLE.length],
                  height: 'sm',
                })}
              />
            ))}
          </div>
        </div>
        <div className="card rise d2">
          <div className="cb" style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
            <span className={skeletonLine({ height: 'field' })} />
            <span className={skeletonLine({ height: 'field' })} />
          </div>
        </div>
      </div>
    </div>
  );
}
